<mat-card class="crud-search-card">
  <mat-card-title>Storage Location PLI: {{locationName}}</mat-card-title>
  <mat-card-content>
    <form [formGroup]="searchForm">
      <div class="search-section">


        <mat-form-field matTooltip="Created By" [matTooltipDisabled]="disabledTooltip(this.createdBy)">
          <mat-label i18n="@@type.FirearmStorageLocationPLI.createdBy">Created By</mat-label>
          <input matInput formControlName="createdBy" id="createdByFilterInput"
              (ngModelChange)="createdByChanging($event)" [(ngModel)]="createdByFilter"
              (ngModelChange)="createdByChanged($event)" #createdByFilterInput
              maxlength="255" placeholder="Created By">
        </mat-form-field>

                <mat-form-field matTooltip="Date Created From" [matTooltipDisabled]="disabledTooltip(this.createdDateGreaterThanOrEqualTo)">
          <mat-label i18n="@@type.FirearmStorageLocationPLI.createdDateGreaterThanOrEqualTo">Date Created From</mat-label>
          <input matInput formControlName="createdDateGreaterThanOrEqualTo" id="createdDateGreaterThanOrEqualToFilterInput"
              (ngModelChange)="createdDateGreaterThanOrEqualToChanging($event)" [(ngModel)]="createdDateGreaterThanOrEqualToFilter"
              (ngModelChange)="createdDateGreaterThanOrEqualToChanged($event)" #createdDateGreaterThanOrEqualToFilterInput
              [matDatepicker]="createdDateGreaterThanOrEqualToDatePicker" (dateChange)="maybeDoAutoSearch()"
              placeholder="Date Created From">
          <mat-datepicker-toggle matSuffix [for]="createdDateGreaterThanOrEqualToDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #createdDateGreaterThanOrEqualToDatePicker color="primary"></mat-datepicker>
        </mat-form-field>
        <mat-form-field matTooltip="Date Created To" [matTooltipDisabled]="disabledTooltip(this.createdDateLessThanOrEqualTo)">
          <mat-label i18n="@@type.FirearmStorageLocationPLI.createdDateLessThanOrEqualTo">Date Created To</mat-label>
          <input matInput formControlName="createdDateLessThanOrEqualTo" id="createdDateLessThanOrEqualToFilterInput"
              (ngModelChange)="createdDateLessThanOrEqualToChanging($event)" [(ngModel)]="createdDateLessThanOrEqualToFilter"
              (ngModelChange)="createdDateLessThanOrEqualToChanged($event)" #createdDateLessThanOrEqualToFilterInput
              [matDatepicker]="createdDateLessThanOrEqualToDatePicker" (dateChange)="maybeDoAutoSearch()"
              placeholder="Date Created To">
          <mat-datepicker-toggle matSuffix [for]="createdDateLessThanOrEqualToDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #createdDateLessThanOrEqualToDatePicker color="primary"></mat-datepicker>
        </mat-form-field>

                <mat-form-field matTooltip="Updated By" [matTooltipDisabled]="disabledTooltip(this.updatedBy)">
          <mat-label i18n="@@type.FirearmStorageLocationPLI.updatedBy">Updated By</mat-label>
          <input matInput formControlName="updatedBy" id="updatedByFilterInput"
              (ngModelChange)="updatedByChanging($event)" [(ngModel)]="updatedByFilter"
              (ngModelChange)="updatedByChanged($event)" #updatedByFilterInput
              maxlength="255" placeholder="Updated By">
        </mat-form-field>

        <mat-form-field matTooltip="Date Updated From" [matTooltipDisabled]="disabledTooltip(this.updatedDateGreaterThanOrEqualTo)">
          <mat-label i18n="@@type.FirearmStorageLocationPLI.updatedDateGreaterThanOrEqualTo">Date Updated From</mat-label>
          <input matInput formControlName="updatedDateGreaterThanOrEqualTo" id="updatedDateGreaterThanOrEqualToFilterInput"
              (ngModelChange)="updatedDateGreaterThanOrEqualToChanging($event)" [(ngModel)]="updatedDateGreaterThanOrEqualToFilter"
              (ngModelChange)="updatedDateGreaterThanOrEqualToChanged($event)" #updatedDateGreaterThanOrEqualToFilterInput
              [matDatepicker]="updatedDateGreaterThanOrEqualToDatePicker" (dateChange)="maybeDoAutoSearch()"
              placeholder="Date Updated From">
          <mat-datepicker-toggle matSuffix [for]="updatedDateGreaterThanOrEqualToDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #updatedDateGreaterThanOrEqualToDatePicker color="primary"></mat-datepicker>
        </mat-form-field>
        <mat-form-field matTooltip="Date Updated To" [matTooltipDisabled]="disabledTooltip(this.updatedDateLessThanOrEqualTo)">
          <mat-label i18n="@@type.FirearmStorageLocationPLI.updatedDateLessThanOrEqualTo">Date Updated To</mat-label>
          <input matInput formControlName="updatedDateLessThanOrEqualTo" id="updatedDateLessThanOrEqualToFilterInput"
              (ngModelChange)="updatedDateLessThanOrEqualToChanging($event)" [(ngModel)]="updatedDateLessThanOrEqualToFilter"
              (ngModelChange)="updatedDateLessThanOrEqualToChanged($event)" #updatedDateLessThanOrEqualToFilterInput
              [matDatepicker]="updatedDateLessThanOrEqualToDatePicker" (dateChange)="maybeDoAutoSearch()"
              placeholder="Date Updated To">
          <mat-datepicker-toggle matSuffix [for]="updatedDateLessThanOrEqualToDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #updatedDateLessThanOrEqualToDatePicker color="primary"></mat-datepicker>
        </mat-form-field>

      </div>

      <div class="search-section">

          <mat-form-field matTooltip="Comments" [matTooltipDisabled]="disabledTooltip(this.comments)">
          <mat-label i18n="@@type.FirearmStorageLocationPLI.comments">Comments</mat-label>
          <input matInput formControlName="comments" id="commentsFilterInput"
              (ngModelChange)="commentsChanging($event)" [(ngModel)]="commentsFilter"
              (ngModelChange)="commentsChanged($event)" #commentsFilterInput
              maxlength="1000" placeholder="Comments">
        </mat-form-field>

        <mat-form-field matTooltip="Select a Has Documents from the list" [matTooltipDisabled]="disabledTooltip(this.hasDocuments)">
          <mat-label i18n="@@type.FirearmStorageLocationPLI.hasDocuments">Has Documents</mat-label>
          <mat-select formControlName="hasDocuments" id="hasDocumentsFilterInput"
              (ngModelChange)="hasDocumentsChanging($event)" [(ngModel)]="hasDocumentsFilter"
              (ngModelChange)="hasDocumentsChanged($event)" #hasDocumentsFilterInput>
            <mat-option>Any</mat-option>
            <mat-option [value]="true" i18n="@@type.boolean.true">Yes</mat-option>
            <mat-option [value]="false" i18n="@@type.boolean.false">No</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field matTooltip="Valid From Date From" [matTooltipDisabled]="disabledTooltip(this.validFromDateGreaterThanOrEqualTo)">
          <mat-label i18n="@@type.FirearmStorageLocationPLI.validFromDateGreaterThanOrEqualTo">Valid From Date (From)</mat-label>
          <input matInput formControlName="validFromDateGreaterThanOrEqualTo" id="validFromDateGreaterThanOrEqualToFilterInput"
              (ngModelChange)="validFromDateGreaterThanOrEqualToChanging($event)" [(ngModel)]="validFromDateGreaterThanOrEqualToFilter"
              (ngModelChange)="validFromDateGreaterThanOrEqualToChanged($event)" #validFromDateGreaterThanOrEqualToFilterInput
              [matDatepicker]="validFromDateGreaterThanOrEqualToDatePicker" (dateChange)="maybeDoAutoSearch()"
              placeholder="Valid From Date From">
          <mat-datepicker-toggle matSuffix [for]="validFromDateGreaterThanOrEqualToDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #validFromDateGreaterThanOrEqualToDatePicker color="primary"></mat-datepicker>
        </mat-form-field>

        <mat-form-field matTooltip="Valid To Date To" [matTooltipDisabled]="disabledTooltip(this.validToDateLessThanOrEqualTo)">
          <mat-label i18n="@@type.FirearmStorageLocationPLI.validToDateLessThanOrEqualTo">Valid To Date (To)</mat-label>
          <input matInput formControlName="validToDateLessThanOrEqualTo" id="validToDateLessThanOrEqualToFilterInput"
              (ngModelChange)="validToDateLessThanOrEqualToChanging($event)" [(ngModel)]="validToDateLessThanOrEqualToFilter"
              (ngModelChange)="validToDateLessThanOrEqualToChanged($event)" #validToDateLessThanOrEqualToFilterInput
              [matDatepicker]="validToDateLessThanOrEqualToDatePicker" (dateChange)="maybeDoAutoSearch()"
              placeholder="Valid To Date To">
          <mat-datepicker-toggle matSuffix [for]="validToDateLessThanOrEqualToDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #validToDateLessThanOrEqualToDatePicker color="primary"></mat-datepicker>
        </mat-form-field>


		<mat-slide-toggle floatLabel="always" appearance="none" color="primary"  *ngIf="autoSearchControlsEnabled"
          [(ngModel)]="autoSearch"  [ngModelOptions]="{standalone: true}">
            Auto Search
        </mat-slide-toggle>

        <button mat-raised-button color="primary" class="action-button" (click)="forceSearch()" type="button"
          i18n="@@actions.search">Search</button>


        <button mat-raised-button color="primary" class="action-button" (click)="clearFilters()" type="button"
          [disabled]="!allowsClearFilters()" i18n="@@actions.clearFilters">Clear Filters</button>
      </div>

    </form>

    <div class="mat-elevation-z8">
      <div class="mat-table-wrapper">
        <mat-table #table [dataSource]="dataSource" matSort
                           matSortDirection="asc" matSortDisableClear cdkDropList cdkDropListLockAxis="x"
                           cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" Group>

          <ng-container matColumnDef="firearmStorageLocationPLIId">
            <mat-header-cell [crud-column-header]="columns.column('firearmStorageLocationPLIId')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.FirearmStorageLocationPLI.firearmStorageLocationPLIId">
                Firearm Storage Location PLI Id 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.firearmStorageLocationPLIId | number:'1.0-2':'en-GB'}}
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="firearmStorageLocation.firearmStorageLocationId">
            <mat-header-cell [crud-column-header]="columns.column('firearmStorageLocation.firearmStorageLocationId')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.FirearmStorageLocationPLI.firearmStorageLocation">
                Firearm Storage Location 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.firearmStorageLocation?.firearmStorageLocationId}} - {{element.firearmStorageLocation?.description}}
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="comments">
            <mat-header-cell [crud-column-header]="columns.column('comments')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.FirearmStorageLocationPLI.comments">
                Comments 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.comments}}
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="createdBy">
            <mat-header-cell [crud-column-header]="columns.column('createdBy')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.FirearmStorageLocationPLI.createdBy">
                Created By 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.createdBy}}
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="createdDate">
            <mat-header-cell [crud-column-header]="columns.column('createdDate')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.FirearmStorageLocationPLI.createdDate">
                Date Created
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.createdDate | uimDateTimeFormat}}
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="documentUploadedBy">
            <mat-header-cell [crud-column-header]="columns.column('documentUploadedBy')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.FirearmStorageLocationPLI.documentUploadedBy">
                Document Uploaded By 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.documentUploadedBy}}
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="hasDocuments">
            <mat-header-cell [crud-column-header]="columns.column('hasDocuments')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.FirearmStorageLocationPLI.hasDocuments">
                Has Documents 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              <mat-icon *ngIf="element.hasDocuments">check_box</mat-icon><mat-icon *ngIf="!element.hasDocuments">check_box_outline_blank</mat-icon>
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="lockVersion">
            <mat-header-cell [crud-column-header]="columns.column('lockVersion')" *matHeaderCellDef 
              cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.FirearmStorageLocationPLI.lockVersion">
                Lock Version 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.lockVersion | number:'1.0-2':'en-GB'}}
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="updatedBy">
            <mat-header-cell [crud-column-header]="columns.column('updatedBy')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.FirearmStorageLocationPLI.updatedBy">
                Updated By 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.updatedBy}}
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="updatedDate">
            <mat-header-cell [crud-column-header]="columns.column('updatedDate')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.FirearmStorageLocationPLI.updatedDate">
                Date Updated
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.updatedDate | uimDateTimeFormat}}
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="validFromDate">
            <mat-header-cell [crud-column-header]="columns.column('validFromDate')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.FirearmStorageLocationPLI.validFromDate">
                Valid From Date 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.validFromDate | uimDateFormat}}
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="validToDate">
            <mat-header-cell [crud-column-header]="columns.column('validToDate')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.FirearmStorageLocationPLI.validToDate">
                Valid To Date 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.validToDate | uimDateFormat}}
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="actions" stickyEnd>
            <mat-header-cell class="search-column-actions mat-elevation-z9" *matHeaderCellDef>
              <span i18n="@@common.actions">Actions</span>
              <app-column-picker-dialog-launcher [columns]="columns">
              </app-column-picker-dialog-launcher>
            </mat-header-cell>
            <mat-cell *matCellDef="let element" class="search-column-actions mat-elevation-z9">
              <button class="action-button" *ngIf="allowsEdit(element)" mat-raised-button color="primary"
                [routerLink]="editRoute(element)" [queryParams]="editRouteQueryParams()" i18n="@@actions.edit" id="actions.edit">Edit</button>
              <button class="action-button" [queryParams]="viewRouteQueryParams()" *ngIf="allowsView(element)" mat-raised-button color="primary"
                [routerLink]="viewRoute(element)" i18n="@@actions.view" id="actions.view">View</button>
              <button class="action-button" *ngIf="allowsDelete(element)" mat-raised-button color="accent"
                (click)="deleteWithConfirmation(element)" i18n="@@actions.delete" id="actions.delete">Delete</button>
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="columns.displayedColumns" class="search-table"></mat-header-row>
          <mat-row *matRowDef="let row; columns: columns.displayedColumns;" class="search-table"></mat-row>

        </mat-table>
      </div>
      <mat-paginator [length]="pageInfo.totalElements" [pageSize]="pageInfo.size" [pageSizeOptions]="pageSizes">
      </mat-paginator>

      <button class="action-button" *ngIf="allowsCreate()" mat-raised-button color="primary" [routerLink]="createRoute()"
        [queryParams]="createRouteQueryParams()" i18n="@@actions.create" id="actions.create">Create</button>
      <button class="action-button" *ngIf="allowsBack()" mat-raised-button color="accent" [routerLink]="backRoute()"
        [queryParams]="backRouteQueryParams()" i18n="@@actions.back" id="actions.back">Back</button>
    </div>
  </mat-card-content>
</mat-card>
